// STATES AND STATUSES

const ACTION_STATES = {
  REQUIRED: 'REQUIRED',
  OPTIONAL: 'OPTIONAL',
  FORBIDDEN: 'FORBIDDEN'
};

const TRANSACTION_STATES = {
  FINISHED: 'FINISHED',
  INCOMPLETE: 'INCOMPLETE',
  EXPIRED: 'EXPIRED',
  ERROR: 'error',
  SUCCESS: 'success',
  REJECTED: 'rejected'
};

const TRANSACTION_STATUSES = {
  OK: 'OK',
  ERROR: 'ERROR'
};

const SIGN_STATUSES = {
  CHECKOUT_SIGN_NOT_STARTED: 'CHECKOUT_SIGN_NOT_STARTED',
  CHECKOUT_SIGN_NOT_COMPLETED: 'CHECKOUT_SIGN_NOT_COMPLETED',
  CHECKOUT_SIGN_FAILED: 'CHECKOUT_SIGN_FAILED',
  CHECKOUT_NOT_SIGNED: 'CHECKOUT_NOT_SIGNED'
};

const PAY_STATUSES = {
  CHECKOUT_PAY_NOT_COMPLETED: 'CHECKOUT_PAY_NOT_COMPLETED', // Keep retrying
  CHECKOUT_SWISH_NOT_COMPLETED: 'CHECKOUT_SWISH_NOT_COMPLETED', // Keep retrying
  CHECKOUT_PAY_FAILED: 'CHECKOUT_PAY_FAILED'
};

const SWISH_ERRORS = {
  CHECKOUT_SWISH_TIMEOUT: 'CHECKOUT_SWISH_TIMEOUT',
  CHECKOUT_SWISH_RECURRING_NOT_OFFERED: 'CHECKOUT_SWISH_RECURRING_NOT_OFFERED',
  CHECKOUT_SWISH_USER_DECLINED_APP: 'CHECKOUT_SWISH_USER_DECLINED_APP',
  CHECKOUT_SWISH_USER_DECLINED_SIGNING: 'CHECKOUT_SWISH_USER_DECLINED_SIGNING',
  CHECKOUT_SWISH_AGE_INVALID: 'CHECKOUT_SWISH_AGE_INVALID',
  CHECKOUT_SWISH_TIN_MISMATCH: 'CHECKOUT_SWISH_TIN_MISMATCH',
  CHECKOUT_SWISH_DECLINED_BANK: 'CHECKOUT_SWISH_DECLINED_BANK'
};

// NAVIGATION STEPS

const APP_STEPS = {
  ORDER_SUMMARY: 'order-summary',
  PERSONAL_INFORMATION: 'personal-information',
  PAYMENT: 'payment',
  BANK: 'bank-id',
  SIGN: 'sign',
  SUCCESS: 'success',
  ERROR: 'error',
  PRINT: 'print'
};

const AUTOGIRO_STEPS = {
  ADD_BANK_ACCOUNT: 'add-bank-account',
  CONNECTING_BANK: 'connecting-bank',
  ACCOUNT_SELECTION: 'account-selection',
  MAIN_BANKS: 'main-banks',
  BANK_LIST: 'bank-list',
  ACCOUNT_FORM: 'account',
  BILLING: 'billing',
  SUMMARY: 'summary',
  CLOSE_CONFIRMATION: 'close-confirmation',
  START_SIGN: 'start-sign'
};

const BETALINGSSERVICE_STEPS = {
  ADD_BANK_ACCOUNT: 'add-bank-account',
  CONNECTING_BANK: 'connecting-bank',
  ACCOUNT_SELECTION: 'account-selection',
  MAIN_BANKS: 'main-banks',
  BANK_LIST: 'bank-list',
  ACCOUNT_FORM: 'account',
  BILLING: 'billing',
  SUMMARY: 'summary',
  CLOSE_CONFIRMATION: 'close-confirmation',
  START_SIGN: 'start-sign'
};

const CARD_STEPS = {
  WAIT: 'wait',
  RETRY: 'retry',
  CLOSE_CONFIRMATION: 'close-confirmation'
};

const SWISH_STEPS = {
  SELECT_DEVICE: 'select-device',
  OPEN: 'open',
  QR: 'qr',
  WAIT: 'wait',
  RETRY: 'retry',
  CLOSE_CONFIRMATION: 'close-confirmation'
};

const AVTALEGIRO_STEPS = {
  OPEN: 'open',
  WAIT: 'wait',
  CANCELLED: 'cancelled',
  ERROR: 'error',
  CLOSE_CONFIRMATION: 'close-confirmation'
};

const EXTERNAL_SIGNING_STEPS = {
  OPEN: 'open',
  QR: 'qr',
  WAIT: 'wait',
  RETRY: 'retry'
};

const INVOICE_STEPS = {
  BILLING_SELECTOR: 'billing-selector',
  BILLING_EDITOR: 'billing-editor',
  CLOSE_CONFIRMATION: 'close-confirmation'
};

const SIGN_STEPS = {
  OPEN: 'open',
  QR: 'qr',
  WAIT: 'wait',
  RETRY: 'retry',
  PHONE_CONFIRMATION: 'phone-confirmation',
  CODE_CONFIRMATION: 'code-confirmation'
};

const SEPA_STEPS = {
  ADD_BANK_ACCOUNT: 'add-bank-account',
  CONNECTING_BANK: 'connecting-bank',
  ACCOUNT_SELECTION: 'account-selection',
  MAIN_BANKS: 'main-banks',
  BANK_LIST: 'bank-list',
  ACCOUNT_FORM: 'account',
  BILLING: 'billing',
  SUMMARY: 'summary',
  CLOSE_CONFIRMATION: 'close-confirmation',
  START_SIGN: 'start-sign'
};

// TYPES

const ANALYTICS_EVENTS = {
  // Pages
  LOAD: 'wtb-checkout-load',
  DETAILS: 'wtb-details',
  PAYMENT_SELECTED: 'wtb-payment-selected',
  SUCCESS: 'wtb-success',
  REJECTED: 'wtb-rejected',
  ERROR: 'wtb-error',
  JS_ERROR: 'wtb-js-error',
  EMAIL_VALIDATION: 'wtb-email-validation',
  RETRY: 'wtb-autogiro-retry',

  // Steps
  ORDER_SUMMARY_STEP: 'wtb-order-summary-step',
  PERSONAL_INFORMATION_STEP: 'wtb-personal-information-step',
  SELECT_PAYMENT_PLAN_STEP: 'wtb-select-payment-plan-step',

  // Info
  PERSONAL_INFO_TIMING: 'wtb-personal-info-timing',
  CAMPAIGN: 'wtb-selected-campaign',
  MERCHANT: 'wtb-current-merchant',
  SELECTED_PAYMENT_PLAN: 'wtb-selected-payment-plan',

  AUTOGIRO: {
    ADD_BANK_ACCOUNT: 'wtb-autogiro-add-bank-account',
    CONNECTING_BANK: 'wtb-autogiro-connecting-bank',
    ACCOUNT_SELECTION: 'wtb-autogiro-account-selection',
    START_TINK_BUTTON: 'wtb-start_tink_button',
    START_FINSHARK_BUTTON: 'wtb-start_finshark_button',
    MAIN_BANKS: 'wtb-autogiro-main-banks',
    BANK_LIST: 'wtb-autogiro-bank-list',
    ACCOUNT_FORM: 'wtb-autogiro-account-form',
    BILLING: 'wtb-autogiro-billing',
    SUMMARY: 'wtb-autogiro-summary',
    CLOSE_CONFIRMATION: 'wtb-autogiro-close-confirmation',
    START_SIGN: 'wtb-autogiro-start-sign'
  },

  BETALINGSSERVICE: {
    ADD_BANK_ACCOUNT: 'wtb-betalingsservice-add-bank-account',
    CONNECTING_BANK: 'wtb-betalingsservice-connecting-bank',
    ACCOUNT_SELECTION: 'wtb-betalingsservice-account-selection',
    START_TINK_BUTTON: 'wtb-start_tink_button',
    START_FINSHARK_BUTTON: 'wtb-start_finshark_button',
    MAIN_BANKS: 'wtb-betalingsservice-main-banks',
    BANK_LIST: 'wtb-betalingsservice-bank-list',
    ACCOUNT_FORM: 'wtb-betalingsservice-account-form',
    BILLING: 'wtb-betalingsservice-billing',
    SUMMARY: 'wtb-betalingsservice-summary',
    CLOSE_CONFIRMATION: 'wtb-betalingsservice-close-confirmation',
    START_SIGN: 'wtb-betalingsservice-start-sign'
  },

  SEPA: {
    ADD_BANK_ACCOUNT: 'wtb-sepa-add-bank-account',
    CONNECTING_BANK: 'wtb-sepa-connecting-bank',
    ACCOUNT_SELECTION: 'wtb-sepa-account-selection',
    START_TINK_BUTTON: 'wtb-start_tink_button',
    START_FINSHARK_BUTTON: 'wtb-start_finshark_button',
    MAIN_BANKS: 'wtb-sepa-main-banks',
    BANK_LIST: 'wtb-sepa-bank-list',
    ACCOUNT_FORM: 'wtb-sepa-account-form',
    BILLING: 'wtb-sepa-billing',
    SUMMARY: 'wtb-sepa-summary',
    CLOSE_CONFIRMATION: 'wtb-sepa-close-confirmation',
    START_SIGN: 'wtb-sepa-start-sign'
  },

  INVOICE: {
    BILLING_SELECTOR: 'wtb-invoice-billing-selector',
    BILLING_EDITOR: 'wtb-invoice-billing-editor'
  },

  SWISH: {
    WAIT: 'wtb-swish-wait',
    RETRY: 'wtb-swish-retry',
    CLOSE_CONFIRMATION: 'wtb-swish-close-confirmation'
  },

  SIGN: {
    OPEN: 'wtb-sign-open',
    WAIT: 'wtb-sign-wait',
    SMS_PHONE_CONFIRMATION: 'wtb-sms-sign-phone-confirmation',
    SMS_CODE_CONFIRMATION: 'wtb-sms-sign-code-confirmation'
  },

  RETRY_EVENT_PARAMS: {
    ACCOUNT: 'account_selection_failed',
    SIGN: 'sign_failed'
  }
};

const PAYMENT_TYPES = {
  CARD: 'CARD',
  INVOICE: 'INVOICE',
  AUTOGIRO: 'AUTOGIRO',
  BETALINGSSERVICE: 'BETALINGSSERVICE',
  AVTALEGIRO: 'AVTALEGIRO',
  AVTALEGIRO_MOCK: 'AVTALEGIRO_MOCK',
  SEPA: 'SEPA',
  SWISH: 'SWISH'
};

const SIGN_SOURCES = {
  AUTOGIRO_SUMMARY: 'AUTOGIRO_SUMMARY',
  BETALINGSSERVICE_SUMMARY: 'BETALINGSSERVICE_SUMMARY',
  SEPA_SUMMARY: 'SEPA_SUMMARY',
  INVOICE: 'INVOICE'
};

const SIGN_TYPES = {
  NONE: 'NONE',
  ZIGNSEC: 'ZIGNSEC', // BankID + Nordic sign
  ZIGNSEC_MOCK: 'ZIGNSEC_MOCK',
  SMS: 'SMS',
  SMS_MOCK: 'SMS_MOCK'
};

const ICON_TYPES = {
  BANKID: 'bankid'
};

// How to get payment details
const ACCOUNT_AUTH_TYPES = {
  NONE: 'NONE',
  AVTALEGIRO: 'AVTALEGIRO',
  AVTALEGIRO_MOCK: 'AVTALEGIRO_MOCK',
  BANK: 'BANK', // For direct bank integrations (BankID, SEPA, etc)
  BANK_MOCK: 'BANK_MOCK',
  CARD: 'CARD',
  CARD: 'CARD_MOCK'
};
const PAY_TYPES = ACCOUNT_AUTH_TYPES;
const ACCOUNT_AUTH_BANK_PROVIDERS = {
  FINSHARK: 'FINSHARK',
  FINSHARK_MOCK: 'FINSHARK_MOCK'
};
const ACCOUNT_AUTH_CARD_PROVIDERS = {
  ADYEN: 'ADYEN',
  ADYEN_MOCK: 'ADYEN_MOCK'
};

// MISC

const BILLING_FIELDS = {
  name: true,
  nationalId: false,
  phone: false,
  email: false,
  address: true
};

const CANCELLATION_POLICY_PERIODS = {
  DAYS: 'DAYS',
  NONE: 'NONE'
};

// ERRORS

const ERRORS = {
  INVALID_FORMAT: 'Invalid format',
  INVALID_DATA: 'INVALID_DATA',
  INVALID_PARAMETER: 'INVALID_PARAMETER',
  BUSY: 'BUSY'
};

const IBAN_ERRORS = {
  ALPHANUMERIC: 'ALPHANUMERIC',
  COUNTRY_CODE: 'COUNTRY_CODE',
  UNSUPPORTED_COUNTRY: 'UNSUPPORTED_COUNTRY',
  INVALID_LENGTH: 'INVALID_LENGTH',
  INVALID_CHECKSUM: 'INVALID_CHECKSUM'
};

const ERROR_TYPES = {
  NO_INTERNET: 'NO_INTERNET',
  CHECKOUT_NOT_OPENED: 'CHECKOUT_NOT_OPENED',
  EXPIRED: 'EXPIRED'
};

const SMS_SIGN_ERRORS = {
  WRONG_CODE: 'CHECKOUT_SIGN_NOT_COMPLETED',
  MAX_CODE_RETRIES: 'CHECKOUT_SIGN_FAILED',
  EXPIRED_CODE: 'CHECKOUT_SIGN_EXPIRED'
};

export {
  ACTION_STATES,
  TRANSACTION_STATES,
  TRANSACTION_STATUSES,
  SIGN_STATUSES,
  PAY_STATUSES,
  SWISH_ERRORS,

  APP_STEPS,
  AUTOGIRO_STEPS,
  BETALINGSSERVICE_STEPS,
  AVTALEGIRO_STEPS,
  EXTERNAL_SIGNING_STEPS,
  INVOICE_STEPS,
  SIGN_STEPS,
  SEPA_STEPS,
  CARD_STEPS,
  SWISH_STEPS,

  ACCOUNT_AUTH_TYPES,
  ACCOUNT_AUTH_BANK_PROVIDERS,
  ACCOUNT_AUTH_CARD_PROVIDERS,
  ANALYTICS_EVENTS,
  PAYMENT_TYPES,
  PAY_TYPES,
  SIGN_SOURCES,
  SIGN_TYPES,
  ICON_TYPES,

  BILLING_FIELDS,
  CANCELLATION_POLICY_PERIODS,

  ERRORS,
  ERROR_TYPES,
  IBAN_ERRORS,
  SMS_SIGN_ERRORS
};
